<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
// import { validRequired } from '@/common/elementValid.js';
import googleads from '@/backend/services/googleAds/googleAds.js';

import keywordFormList from './keywordFormList.vue';

function getFormData(_obj, vm) {
	let { attributes } = vm;
	let { list } = attributes;
	return {
		orderType: {
			label: '忽略的词组将不再进行AI判定',
		},
		list: {
			formType: keywordFormList,
			value: list || [],
			column: [
				{
					label: '忽略搜索关键词',
					type: 'inputBox',
					bind: 'searchTermName',
				},
				{
					label: '广告系列',
					type: 'tooltip',
					bind: 'campaignName',
				},
				{
					label: '广告组',
					type: 'tooltip',
					bind: 'adGroupName',
				},
			],
		},
	};
}

async function submit(data) {
	let { attributes } = this;
	let { serviceId } = attributes;

	delete data.orderType;

	try {
		await googleads.igonoreSearchKeyword(data, serviceId);
		this.$message.success('忽略成功');
		this.$emit('confirm');
	} catch (error) {
		this.$emit('cancel');
	}
}

function cancel(self) {
	self.$emit('cancel');
}

function onShowLoad(props) {
	return props || {};
}

const componentForm = formPanelCreate(
	{
		getFormData,
		submit,
		cancel,
	},
	{
		subButton: '确认忽略',
		labelPosition: 'top',
	}
);

export default formDialogCreate({
	name: 'ignoreKeywordFormDialog',
	onShowLoad,
	componentForm,
});
</script>
